import { ReactNode } from 'react';
import { CalendarProps } from 'react-calendar';

export enum ACTIVE_DAY {
  START = 'startDay',
  END = 'endDay,',
}

export interface ICalendarSubmitDate {
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export interface ICalendarProps extends CalendarProps {
  start_date: string | number | undefined;
  end_date: string | number | undefined;
  changeDate: ({ startDate, endDate }: ICalendarSubmitDate) => void;
  type?: 'past' | 'future';
  disabledAutoClose?: boolean;
  selectByDay?: boolean;
  fieldClassName?: string;
  horizontal?: 'left' | 'center' | 'right' | 'start' | 'end';
  vertical?: 'bottom' | 'center' | 'top';
  hideCloseIcon?: boolean;
  children?: ReactNode;
}

export interface ICalendarState {
  start_date: string | number | undefined;
  end_date: string | number | undefined;
  calendarModal: boolean;
  activeDay: ACTIVE_DAY;
}
